import { motion } from "framer-motion";
import PreviewBanner from "./PreviewBanner";

// Vault door: two black slabs slide apart to reveal content
export default function HeroVault() {
  return (
    <div className="min-h-[100svh] pt-24 relative overflow-hidden bg-[#030303]" data-testid="preview-hero-vault">
      <PreviewBanner title="Vault Door" kind="Hero" />

      {/* corner markings */}
      <div className="absolute top-24 left-6 md:left-10 overline text-[#666] z-30">Ξ VAULT SEQUENCE</div>
      <div className="absolute top-24 right-6 md:right-10 overline text-[#666] z-30">CLEARANCE · 001</div>
      <div className="absolute bottom-6 left-6 md:left-10 overline text-[#666] z-30 flex items-center gap-3">
        <span className="tier-dot phantom blink" /> BIOMETRIC MATCH
      </div>
      <div className="absolute bottom-6 right-6 md:right-10 overline text-[#666] z-30">AUSTRALIAN OWNED · SYD</div>

      {/* central composition */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-[80svh] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 1.4 }}
          className="overline text-[#666] mb-6"
        >
          — ACCESS GRANTED —
        </motion.div>

        <div className="relative w-full max-w-[900px] aspect-[3/2] border border-[#1A1A1A] overflow-hidden">
          {/* content behind doors */}
          <div className="absolute inset-0 flex flex-col items-center justify-center p-8 text-center bg-[#080808]">
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.2, delay: 1.8, ease: [0.22, 1, 0.36, 1] }}
              className="font-display uppercase text-5xl md:text-[9vw] leading-[0.9] tracking-tight"
            >
              Phantom<br />
              <span className="text-[#7C3AED]">Phone.</span>
            </motion.h1>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 2.4 }}
              className="mt-6 overline"
            >
              GrapheneOS · Australian owned · No telemetry
            </motion.div>
          </div>

          {/* left slab */}
          <div
            className="slab-left absolute inset-y-0 left-0 w-1/2 bg-[#030303] flex items-center justify-end pr-6 z-20"
            style={{
              backgroundImage:
                "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.02) 50%, transparent 100%)",
            }}
          >
            <div className="flex flex-col items-end gap-3 text-right">
              <div className="overline text-[#888]">LEFT SLAB</div>
              <div className="font-mono text-[#444] text-xs">42.3° S · 145.7° E</div>
              <div className="w-16 h-16 border border-[#333] flex items-center justify-center">
                <div className="w-8 h-8 border border-[#7C3AED] rotate-45" />
              </div>
            </div>
          </div>

          {/* right slab */}
          <div
            className="slab-right absolute inset-y-0 right-0 w-1/2 bg-[#030303] flex items-center justify-start pl-6 z-20"
            style={{
              backgroundImage:
                "linear-gradient(-90deg, transparent 0%, rgba(255,255,255,0.02) 50%, transparent 100%)",
            }}
          >
            <div className="flex flex-col items-start gap-3">
              <div className="overline text-[#888]">RIGHT SLAB</div>
              <div className="font-mono text-[#444] text-xs">SEAL # PH-2026-Ξ</div>
              <div className="w-16 h-16 border border-[#333] flex items-center justify-center">
                <div className="tier-dot phantom scale-[3]" />
              </div>
            </div>
          </div>

          {/* center seam pulse */}
          <motion.div
            initial={{ scaleY: 0 }}
            animate={{ scaleY: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="absolute inset-y-0 left-1/2 w-px bg-[#7C3AED] opacity-60 z-30"
            style={{ transformOrigin: "center" }}
          />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 2.6, duration: 0.9 }}
          className="mt-16 flex flex-col md:flex-row items-center gap-6"
        >
          <button className="btn-vault danger">Enter the vault</button>
          <button className="btn-ghost">Read the doctrine →</button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 3, duration: 0.6 }}
          className="mt-12 grid grid-cols-3 gap-8 md:gap-16 text-center"
        >
          {[
            ["7", "Devices"],
            ["3", "Tiers"],
            ["0", "Telemetry"],
          ].map(([n, l]) => (
            <div key={l}>
              <div className="font-display text-4xl md:text-6xl">{n}</div>
              <div className="overline mt-2">{l}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}
